import React from "react";
import useTheme from "../../../../common/hooks/useTheme";

const GettingStartedCard = ({
  title,
  text,
  index,
  color,
}: {
  title: string;
  text: string;
  index: number;
  color: string;
}) => {
  const theme = useTheme();

  return (
    <div style={styles.startedCardContainer(theme)}>
      <div style={styles.cardTitleHeader}>
        <div
          style={{
            ...styles.iconWrapper(theme),
            backgroundColor: color,
          }}
        >
          {index}
        </div>
        <div style={styles.startedCardTitle(theme)}>{title}</div>
      </div>
      <div style={styles.startedCardText(theme)}>{text}</div>
    </div>
  );
};

const styles = {
  startedCardContainer: (theme: any) => ({
    backgroundColor: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    borderRadius: "8px",
    padding: "16px",
  }),
  cardTitleHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px",
  },
  iconWrapper: (theme: any) => ({
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
  }),
  startedCardTitle: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "14px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
  startedCardText: (theme: any) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
  }),
};

export default GettingStartedCard;